// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.statusindicator[data-v-142be539] {\n  font-size: 1rem;\n}\n.alarmtext[data-v-142be539] {\n  color: red;\n}\n.warntext[data-v-142be539] {\n  color: orange;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
